// extracted by mini-css-extract-plugin
export default {"root":"styles_root__V3JEf","title":"styles_title__bcnv3","fleetSelectionContainer":"styles_fleetSelectionContainer__d7fx5","tableContainer":"styles_tableContainer__xcJW0"};